import { render } from "./stock-adjust.vue?vue&type=template&id=7b064281"
import script from "./stock-adjust.vue?vue&type=script&lang=js"
export * from "./stock-adjust.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__